  class NutritionalFacts extends HTMLElement {
    constructor() {
      super();
      this.flavorToggles = this.querySelectorAll('.nutritional-facts__flavor-toggle');

      this.flavorToggles.forEach(toggle => {
        toggle.addEventListener('click', this.toggleFlavor.bind(this, toggle));
      });
    }

    toggleFlavor(toggle) {
      const flavor = toggle.closest('.nutritional-facts__flavor');
      const content = toggle.nextElementSibling;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      // Close all other flavors
      this.querySelectorAll('.nutritional-facts__flavor.is-active').forEach(activeFlavor => {
        if (activeFlavor !== flavor) {
          activeFlavor.classList.remove('is-active');
          activeFlavor.querySelector('.nutritional-facts__flavor-toggle').setAttribute('aria-expanded', 'false');
          activeFlavor.querySelector('.nutritional-facts__content').setAttribute('hidden', '');
        }
      });

      // Toggle current flavor
      if (isExpanded) {
        flavor.classList.remove('is-active');
        toggle.setAttribute('aria-expanded', 'false');
        content.setAttribute('hidden', '');
      } else {
        flavor.classList.add('is-active');
        toggle.setAttribute('aria-expanded', 'true');
        content.removeAttribute('hidden');
      }
    }
  }

  customElements.define('nutritional-facts', NutritionalFacts);
